// extracted by mini-css-extract-plugin
module.exports =  {"ratingWrapper":"PostSurveyForm__ratingWrapper--9b47c","textAreaWrapper":"PostSurveyForm__textAreaWrapper--9568e"};